import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";

const links = [
  {
    to: "/account",
    label: "Account",
  },
  {
    to: "/entity/262298569/overview",
    label: "Company Pages",
  },
  {
    to: "/contact-us",
    label: "Contact Us",
  },
  {
    to: "/deals/821978428/documents",
    label: "Deals",
  },
  {
    to: "/deal-creator",
    label: "Deal Creator",
  },
  {
    to: "/esg-views/climate/4000",
    label: "ESG View",
  },
  {
    to: "/standalone-header-footer",
    label:
      "Example local development page of header and footer components used in another app like AEM",
  },
  {
    to: "/monitoring",
    label: "Monitoring",
  },
  {
    to: "/notification-settings",
    label: "Notification Settings",
  },
  {
    to: "/reports/issuers-and-deals/",
    label: "Reports Directory",
  },
  {
    to: "/assistant/chat",
    label: "Research Assistant",
  },
  {
    to: "/research/PBC_1270903",
    label: "Research Views",
  },
  {
    to: "/screener/overview",
    label: "Screener",
  },
  {
    to: "/search-results/all?keyword=ferrari",
    label: "Search",
  },
  {
    to: "/market-segment/structured-finance/clo-and-structured-credit/global/overview",
    label: "Sector Views",
  },
];

export const PageLinks = () => {
  return (
    <Grid
      item
      sx={{
        code: {
          backgroundColor: "#edeff1",
          border: ".1rem solid #0000001a",
          borderRadius: "0.4rem",
          fontFamily:
            'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
          fontSize: "95%",
          padding: "0.15rem",
        },
      }}
    >
      <h2>Page Links</h2>
      <Typography component="span">
        Best to login as <code>gateway_test@moodys-test.com</code> to test
        monitoring.
      </Typography>
      <br />
      <ul>
        {links.map(({ to, label }, index) => (
          <li key={`page-links-${index}`}>
            <Link to={to}>{label}</Link>
          </li>
        ))}
      </ul>
    </Grid>
  );
};
